import { useEffect, useState } from 'react';

/**
 * UseMobile
 */
const UseMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    const match = window.matchMedia('(max-width: 784px)');
    setIsMobile(match.matches);
  };

  return [isMobile];
};
export default UseMobile;
